import React, { useEffect, useState } from 'react';
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import { withRouter } from 'react-router-dom';
import { translate, convertToDecimal, convertToSeparator, formatData, isNullOrEmpty } from '../../../utils/util';

const LogListItem = (props) => {
    const [jsonResponse, setjsonResponse] = useState({});
    const [jsonRequest, setJsonRequest] = useState([]);

    useEffect(() => {
        try {
            if (props.item.jsonResponse?.substring(0, 1) === "{") {
                var response = JSON.parse(props.item.jsonResponse);
                setjsonResponse(response);

            }
        } catch (e) {
            console.log(e)
        }

        try {
            if (props.item.jsonRequest?.substring(0, 1) === "{") {
                var request = JSON.parse(props.item.jsonRequest);
                setJsonRequest(request);

            }
        } catch (e) {
            console.log(e)
            // Default to empty object
        }
        // eslint-disable-next-line
    }, []);


    return (
        <div
            key={`key_${props.item.createdOn}`}
            className="collection-item"
            style={{ backgroundColor: 'white', color: 'black', display: 'block' }}
            onClick={() => props.onClickItem(props.item)}
        >
            <div className="row" style={{ marginBottom: '0px' }}>
                <div className="col s6">
                    <div>{`${translate('physical-confirmation:mvm')}: ${convertToSeparator(props.item.mvmNumber) || ''}`}</div>
                </div>
                <div className="col s6">
                    <div>{translate('physical-confirmation:return')}: {props.item.success ? translate('physical-confirmation:success') : translate('physical-confirmation:fail')}</div>
                </div>
                {!isNullOrEmpty(props.item.jsonResponse) &&
                    <div>
                        <div className="col s6">
                            <div>{`${translate('physical-confirmation:user')}:`}{jsonResponse?.Sheds ? jsonResponse?.Sheds[0]?.EntryUserRegistration : ''}</div>
                        </div>
                        < div className="col s6">
                            <div>{`${translate('load-unload:loadiniciated')}:`} {jsonRequest?.ShedCode} - {jsonRequest?.MovementDescription}</div>
                        </div>
                    </div>
                }
                {isNullOrEmpty(props.item.jsonResponse) &&
                    <div>
                        <div className="col s6">
                            <div>{`${translate('physical-confirmation:user')}:`}{jsonRequest?.Shed?.ExitConferenceUserRegistration}</div>
                        </div>
                        < div className="col s6">
                            <div>{`${translate('load-unload:loadFinished')}:`}{jsonRequest?.ShedCode} - {jsonRequest?.MovementDescription}</div>
                        </div>
                    </div>
                }
                <div className="col s6">
                    <b>{`${formatData(props.item.createdOn)}`}</b>
                </div>
            </div>
        </div >
    )
}

const mapStateToProps = (state) => {
    return {
        sheds: state.loadUnloadReducer.sheds,
    };
};
const mapDispatchToProps = (dispatch) => {

};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(withTranslation()(LogListItem)));
